import { useState } from 'react';

export function ConfirmDialog({ open, title, message, onConfirm, onCancel, variant = 'danger', confirmText = 'Confirmar' }) {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm?.();
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  const colorCls = variant === 'danger' ? 'bg-rose-500 hover:bg-rose-600' : 'bg-cyan-500 hover:bg-cyan-600';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" onClick={onCancel}>
      <div className="bg-panel border border-border rounded-xl shadow-2xl max-w-md w-full p-6" onClick={(e) => e.stopPropagation()}>
        <h3 className="font-semibold text-white text-lg">{title}</h3>
        <p className="mt-2 text-sm text-slate-300">{message}</p>
        <div className="mt-5 flex gap-3 justify-end">
          <button onClick={onCancel} className="px-4 py-2 rounded-md border border-border text-slate-300 hover:bg-panel-2 text-sm font-medium">
            Cancelar
          </button>
          <button onClick={handleConfirm} disabled={loading} className={`px-4 py-2 rounded-md text-white text-sm font-medium ${colorCls} disabled:opacity-50`}>
            {loading ? 'Procesando...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
